import React from 'react';
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Label,
  FormGroup,
  Button
} from 'reactstrap';
import Loading from 'react-loading-animation';
import { TextRupiah } from '../../components/Text';

export const COURIER_GROUP_NAMES = {
  1: 'Shipping fee (all locations)',
  2: 'Pulau Jawa',
  3: 'Luar Pulau Jawa',
  4: 'Papua & Papua Barat',
  5: 'Luar Negri',
};

const linkStyle = { textDecoration: 'underline', color: '#4a4a4a', fontSize: '.75rem' };

export default class ProductVariantCouriers extends React.Component{
  _openShippingRateModal = (e, item) => {
    e.preventDefault();
    this.props.openShippingRateModal({
      id: item.id,
      location_group: item.location_group,
      name: item.name,
      price: item.price,
    })
  }

  _openAddModal = e => {
    e.preventDefault();
    const saved = this.props.shippingRates.map(item => Number(item.location_group));
    this.props.openShippingRateModal({
      id: null,
      location_group: null,
      name: null,
      price: null,
      isAdd: true,
      availableGroups: Object.keys(COURIER_GROUP_NAMES)
        .map(Number)
        .filter(g => !saved.includes(g)),
    })
  }

  render(){
    const { shippingRates, globalShippingFee } = this.props;
    const hasRows = shippingRates.length > 0;
    return(
      <Card>
        <CardHeader>
          <i className="fa fa-align-justify"></i> Shipping Rates
        </CardHeader>
        <CardBody>
          <Loading isLoading={this.props.isLoading}>
            {!hasRows? (
              <div>
                <FormGroup className="mb-2">
                  <Label className="mb-0">
                    <strong>{COURIER_GROUP_NAMES[1]}<br/></strong>
                    {globalShippingFee && globalShippingFee.value !== null?
                      <TextRupiah prefix="Rp. " tag="span" value={globalShippingFee.value}/>
                      : <span className="text-muted">-</span>}
                  </Label>
                  <div>
                    <small className="text-muted">
                      global {globalShippingFee? globalShippingFee.name: 'shipping fee'} setting
                    </small>
                  </div>
                </FormGroup>
                <Button color="link" className="p-0" style={linkStyle} onClick={this._openAddModal}>
                  + Set variant courier for this SKU
                </Button>
              </div>
            ): (
              <div>
                <Row style={{alignItems:'flex-end'}}>
                  {shippingRates.map(item => (
                    <Col xs={6} key={item.id || `group-${item.location_group}`}>
                      <FormGroup>
                        <Label>
                          <strong>
                            {item.name}
                            <Button
                              color="link"
                              className="ml-2 p-0 align-baseline"
                              style={linkStyle}
                              onClick={e => this._openShippingRateModal(e, item)}
                            >
                              <i className="fa fa-pencil"></i> edit
                            </Button>
                            <br/>
                          </strong>
                          <TextRupiah prefix="Rp. " tag="span" value={item.price}/>
                        </Label>
                      </FormGroup>
                    </Col>
                  ))}
                </Row>
                {shippingRates.length < Object.keys(COURIER_GROUP_NAMES).length && (
                  <Button color="link" className="p-0" style={linkStyle} onClick={this._openAddModal}>
                    + Add location group
                  </Button>
                )}
              </div>
            )}
          </Loading>
        </CardBody>
      </Card>
    )
  }
}
